import React, { Suspense, useContext } from 'react';
import { WWW_ORIGIN } from '../../config';

import Auth from '@xometry/auth-context';
import { Spinner } from '@xometry/xometry_loft';
import { lazyWithRetries } from '../../utils/shimport';

interface Props {
  orgId: string;
}

const TeamOnboardingPanelURL = `${WWW_ORIGIN}/quoting/quote/microcomponents/team-onboarding-panel.mjs`;
const LazyTeamOnboardingPanel = lazyWithRetries(TeamOnboardingPanelURL);

const TeamOnboardingPanel = (props: Props) => {
  const { user } = useContext(Auth);
  const { orgId } = props;

  return (
    <Suspense fallback={<Spinner scale="panel" />}>
      <LazyTeamOnboardingPanel orgId={orgId} userId={user?.id} />
    </Suspense>
  );
};

export default TeamOnboardingPanel;
